import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import RoleAssign from '../../components/role/RoleAssign'
import RoleAccess from '../role/RoleAccess'

export default function RoleAssignPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <RoleAssign />
        </>
    )
}
